module.exports = __webpack_public_path__ + "static/img/anima-logo-new.67d1252e.svg";